<template>
    <div class="side-nav-select">
        <CustomSelect :modelValue="modelValue" :options="options" :placeholder="placeholder" :prepend="prepend"
                      @update:modelValue="$emit('update:modelValue', $event)">
        </CustomSelect>
    </div>
</template>

<script>
import CustomSelect from "./CustomSelect.vue";

export default {
    name: 'SideNavSelect',
    components: {CustomSelect},
    props: {
        prepend: {
            type: String,
            default: ''
        },
        modelValue: String,
        placeholder: String,
        options: Array
    }
};
</script>
